import { FC } from 'react'
import ChecklistIcon from '@mui/icons-material/Checklist'
import { SvgIconProps } from '@mui/material/SvgIcon'

export const CheckListIcon: FC<SvgIconProps> = (props: SvgIconProps) => {
  return <ChecklistIcon {...props} />
}
